import { Banner } from '@calendly/ui/components/banner';
import { Button } from '@calendly/ui/components/button';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const warningBannerCss = "w1kiueck";
export const WarningBanner = forwardRef((props, ref) => {
  const type = 'warning';
  return <Banner ref={ref} {...props} type={type} className={classNames(warningBannerCss, props.className)} />;
});
const containerIsPhoneCss = "c10qzg6y";
const containerIsTabletUpCss = "c1i4ufix";
const containerCss = "co8zobr";
export const Container = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Sheet ref={ref} {...props} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone,
    [containerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const imageIsPhoneCss = "i2ajoru";
const imageIsTabletUpCss = "i15cgagy";
const imageCss = "i106z6hz";
export const Image = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(imageCss, {
    [imageIsPhoneCss]: isPhone,
    [imageIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const textContainerCss = "t1dilha3";
export const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, props.className)} />;
});
const spacedTextIsPhoneCss = "s8flzy7";
const spacedTextCss = "s1sxosxh";
export const SpacedText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(spacedTextCss, {
    [spacedTextIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledButtonIsTabletUpCss = "s16z47lm";
const styledButtonCss = "s1whqs83";
export const StyledButton = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <Button ref={ref} {...props} className={classNames(styledButtonCss, {
    [styledButtonIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");